import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as dataLayer from '../snippets/dataLayer';
import * as gtm from '../snippets/gtm';
import * as ot from '../snippets/onetrust';
import * as optimize from '../snippets/optimize';
export function track(trackParams) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var actions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (trackParams) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 2:
            actions = getActions(trackParams);
            pushInitialDataToDataLayer(Object.assign(Object.assign({}, actions), trackParams));
            _context.next = 6;
            return loadScripts(Object.assign(Object.assign({}, actions), trackParams));

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function getActions(trackParams) {
  var dataLayerPushInitial = trackParams.dataLayerPushInitial,
      googleOptimizeId = trackParams.googleOptimizeId,
      googleTagManagerId = trackParams.googleTagManagerId,
      language = trackParams.language,
      market = trackParams.market,
      oneTrust = trackParams.oneTrust;
  return {
    loadGoogleOptimize: !!googleOptimizeId,
    loadGoogleTagManager: !!googleTagManagerId,
    loadOneTrust: oneTrust && market,
    pushInitialData: dataLayerPushInitial && language && market
  };
}

function pushInitialDataToDataLayer(_ref) {
  var language = _ref.language,
      _ref$loggedIn = _ref.loggedIn,
      loggedIn = _ref$loggedIn === void 0 ? false : _ref$loggedIn,
      pushInitialData = _ref.pushInitialData,
      market = _ref.market,
      _ref$userCountry = _ref.userCountry,
      userCountry = _ref$userCountry === void 0 ? '' : _ref$userCountry;

  if (pushInitialData) {
    dataLayer.push({
      language: language,
      loggedIn: loggedIn,
      market: market,
      userCountry: userCountry
    });
  }
}

function loadScripts(_ref2) {
  var loadGoogleOptimize = _ref2.loadGoogleOptimize,
      loadGoogleTagManager = _ref2.loadGoogleTagManager,
      loadOneTrust = _ref2.loadOneTrust,
      googleOptimizeId = _ref2.googleOptimizeId,
      googleOptimizeTimeout = _ref2.googleOptimizeTimeout,
      googleTagManagerId = _ref2.googleTagManagerId,
      googleTagManagerAdditionalData = _ref2.googleTagManagerAdditionalData,
      oneTrustDomainScript = _ref2.oneTrustDomainScript,
      nonce = _ref2.nonce;
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var loaders;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loaders = [];

            if (loadGoogleOptimize) {
              loaders.push(optimize.load({
                id: googleOptimizeId,
                timeout: googleOptimizeTimeout
              }));
            }

            if (loadGoogleTagManager && loadOneTrust) {
              loaders.push(ot.load({
                oneTrustDomainScript: oneTrustDomainScript
              }).then(function () {
                return gtm.load({
                  id: googleTagManagerId,
                  additionalData: googleTagManagerAdditionalData,
                  nonce: nonce
                });
              }));
            } else if (loadOneTrust) {
              loaders.push(ot.load({
                oneTrustDomainScript: oneTrustDomainScript
              }));
            } else if (loadGoogleTagManager) {
              loaders.push(gtm.load({
                id: googleTagManagerId,
                additionalData: googleTagManagerAdditionalData,
                nonce: nonce
              }));
            }

            return _context2.abrupt("return", Promise.all(loaders));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}